import { sidebarPage } from '../utils/sidebarPageLayout.js';

/** ClubOS (Next.js app in /club-os). Override with VITE_CLUB_OS_ORIGIN in .env when deployed. */
const CLUB_OS_ORIGIN =
    typeof import.meta !== 'undefined' && import.meta.env?.VITE_CLUB_OS_ORIGIN
        ? String(import.meta.env.VITE_CLUB_OS_ORIGIN).replace(/\/$/, '')
        : 'http://localhost:3000';

const CLUBS_DATA = [
    {
        name: "FC Robo Queens",
        location: "Mushin, Lagos, Nigeria",
        bio: "FC Robo International, owners of FC Robo Queens, is a privately owned professional football club. Originally an academy for boys, it expanded to include a highly successful women's program, which is now the primary source of its national and international recognition.",
        potential: [
            "Proven track record of international player exports",
            "Dominant presence in the Lagos talent market",
            "Owner-driven stability and grassroots focus"
        ],
        cta: "Open for modest investment – $10,000 can make a difference",
        flag: "nigeria.png"
    },
    {
        name: "Dannaz Ladies",
        location: "Lagos State, Nigeria",
        bio: "Privately owned women's club competing in the NWFL Premiership but operating with limited resources and grassroots focus.",
        potential: [
            "Mid-tier survivor in Africa's deepest women's league",
            "Taps Lagos talent market for quick ROI via player sales"
        ],
        cta: "Open for modest investment – $5,000 can make a difference",
        flag: "nigeria.png"
    },
    {
        name: "DreamStar Ladies",
        location: "Lagos State, Nigeria",
        bio: "Small privately run club in the NWFL Championship (2nd tier), focused on local development.",
        potential: [
            "Lower-division fighter pushing for promotion",
            "Sustainable Lagos-based talent pipeline"
        ],
        cta: "Investment from $5,000 covers promotion season basics",
        flag: "nigeria.png"
    },
    {
        name: "Honey Badgers FC",
        location: "Abuja, Nigeria",
        bio: "Privately owned Championship-level club run by individuals with minimal backing in the nation's capital.",
        potential: [
            "Huge youth population in federal market",
            "High visibility upside for academy building"
        ],
        cta: "Seeking modest capital for visibility and growth",
        flag: "nigeria.png"
    },
    {
        name: "Viamaterras Miyazaki",
        location: "Kyushu, Japan",
        bio: "Independent club in Nadeshiko League Div 1. Founded as a community team with a strong emphasis on local talent development.",
        potential: [
            "Untapped regional talent pools in Southern Japan",
            "Growth potential in under-resourced Kyushu market"
        ],
        cta: "Institutional investment opportunities available",
        flag: "japan.png"
    },
    {
        name: "Kwara Ladies",
        location: "Kwara State, Nigeria",
        bio: "Independent private club in NWFL Championship providing pathways in the North-Central region.",
        potential: [
            "North-Central underserved region advantage",
            "Low-cost entry to create professional pathways"
        ],
        cta: "Open for modest investment – $5,000 can make a difference",
        flag: "nigeria.png"
    },
    {
        name: "Adex Queens",
        location: "Ikotun, Lagos State, Nigeria",
        bio: "Amateur-level privately owned grassroots club operating in the vibrant suburbs of Lagos.",
        potential: [
            "Pure survival club with high growth upside",
            "Taps into underserved Lagos suburb talent pools"
        ],
        cta: "$5,000 transforms training and kit quality",
        flag: "nigeria.png"
    },
    {
        name: "Jagunmolu Queens",
        location: "Idiroko, Ogun State, Nigeria",
        bio: "Small private amateur club strategically located in the border region of Ogun State.",
        potential: [
            "Border-region market development potential",
            "Early-stage entry before NWFL interest peaks"
        ],
        cta: "Low investment builds a new regional market",
        flag: "nigeria.png"
    },
    {
        name: "Yaba Queens",
        location: "Yaba, Lagos State, Nigeria",
        bio: "Independent amateur women's side based in the urban youth and tech hub of Yaba.",
        potential: [
            "Located in a high-density urban youth hub",
            "High engagement potential for community branding"
        ],
        cta: "Minimal funds create high community engagement",
        flag: "nigeria.png"
    },
    {
        name: "Oluyole Flamming Queens",
        location: "Ibadan, Oyo State, Nigeria",
        bio: "Privately run amateur club in Nigeria's second-largest city, focusing on grassroots empowerment.",
        potential: [
            "Massive population base in a key regional market",
            "Lowest entry cost to build Oyo's women's football scene"
        ],
        cta: "Strategic entry into the Oyo State market",
        flag: "nigeria.png"
    },
    {
        name: "FC Phoenix",
        location: "Apapa/Iganmu, Lagos State, Nigeria",
        bio: "Small private amateur team operating in the industrial port-area of Lagos.",
        potential: [
            "Unique port-area location for commercial growth",
            "Positions club for local industrial sponsorships"
        ],
        cta: "$5,000 - $8,000 funds baseline operations",
        flag: "nigeria.png"
    },
    {
        name: "Nana Babes",
        location: "Ore, Ondo State, Nigeria",
        bio: "Privately owned lower-tier club serving as a critical grassroots outlet in the South-West.",
        potential: [
            "Strong regional talent feeder network",
            "Excellent potential for regional player export"
        ],
        cta: "Investment creates regional talent feeders",
        flag: "nigeria.png"
    },
    {
        name: "Moje Queens",
        location: "Kwara State, Nigeria",
        bio: "Small privately operated Championship team with strong regional ties.",
        potential: [
            "Twin club potential with Kwara Ladies",
            "Shared resources amplify impact of modest funding"
        ],
        cta: "Modest funding creates high regional impact",
        flag: "nigeria.png"
    },
    {
        name: "Prince Kazeem Eletu Queens",
        location: "Nigeria",
        bio: "Privately founded club in lower NWFL tiers, modeled after successful owner-driven academies.",
        potential: [
            "Owner-driven stability and focus",
            "Unlocks league stability and player development"
        ],
        cta: "Small capital unlocks significant league potential",
        flag: "nigeria.png"
    },
    {
        name: "Berry Ladies FC",
        location: "Accra, Ghana",
        bio: "Privately owned professional club that climbed from regional divisions to the Ghana Premier League.",
        potential: [
            "Self-made success story in Accra market",
            "Accelerates academy and sponsorship growth"
        ],
        cta: "Strategic investment for Accra market growth",
        flag: "gh.png"
    },
    {
        name: "Faith Ladies FC",
        location: "Accra, Ghana",
        bio: "Independent club established in 2004, competing consistently in the Premier League zones.",
        potential: [
            "Long-running private outfit with proven stability",
            "Taps into the deep Southern Ghana talent pool"
        ],
        cta: "Invest in a stabilized, long-term talent hub",
        flag: "gh.png"
    },
    {
        name: "Jonina Football Academy",
        location: "Greater Accra, Ghana",
        bio: "Privately founded academy club (2021) that rapidly reached the Premier League level.",
        potential: [
            "Pure academy model focused on development",
            "Creates player-trading revenue streams"
        ],
        cta: "$10,000 builds facilities for elite player trading",
        flag: "gh.png"
    },
    {
        name: "Kibera Soccer Women",
        location: "Kibera, Nairobi, Kenya",
        bio: "Community-linked club in the FKF Women's Premier League based in Africa's most iconic urban center.",
        potential: [
            "Iconic location with a massive youth base",
            "High visibility pathways in the heart of Nairobi"
        ],
        cta: "$5,000 creates global visibility and pathways",
        flag: "ke.png"
    },
    {
        name: "Zetech Sparks",
        location: "Nairobi, Kenya",
        bio: "Privately backed university and community-linked club competing in the Premier League.",
        potential: [
            "Strong youth and academic talent pipeline",
            "Scalable into a major regional sports brand"
        ],
        cta: "Scalable investment into a regional brand",
        flag: "ke.png"
    },
    {
        name: "Badgers Academy",
        location: "Cape Town, South Africa",
        bio: "Women-owned and women-run academy club playing in the Sasol Provincial League.",
        potential: [
            "Female-led grassroots leadership model",
            "Expands safe sports spaces for girls in Cape Town"
        ],
        cta: "$10,000 expands safe spaces and elite training",
        flag: "za.png"
    },
    {
        name: "Wakiso Hills Women FC",
        location: "Wakiso District, Uganda",
        bio: "Known as 'The Antelopes,' this club rose from a school team to the FUFA Women Super League.",
        potential: [
            "Grassroots-to-league success story",
            "Accelerates academy growth in rising Ugandan scene"
        ],
        cta: "Support the rise of the Uganda Super League",
        flag: "ug.png"
    },
    {
        name: "Okayama Yunogo Belle",
        location: "Okayama, Japan",
        bio: "A historic Nadeshiko League club run as a citizen's club with deep community and educational roots.",
        potential: [
            "Stable mid-tier performer in Western Japan",
            "Strong talent export pathway to the national team"
        ],
        cta: "Capital injection for elite facility enhancement",
        flag: "japan.png"
    },
    {
        name: "Diavorosso Hiroshima",
        location: "Hiroshima, Japan",
        bio: "Nadeshiko League Division 2 club operating independently with a focus on regional development in Western Honshu.",
        potential: [
            "Access to a passionate regional sports market",
            "Sponsorship upside following men's team success"
        ],
        cta: "Accelerate academy growth in Western Honshu",
        flag: "japan.png"
    },
    {
        name: "Bunnys Gunma FC White Star",
        location: "Gunma, Japan",
        bio: "Citizen's club in the Nadeshiko League run by local enthusiasts with emphasis on youth and women's empowerment.",
        potential: [
            "Rural-urban mix with rising participation",
            "Positions the club as a central regional hub"
        ],
        cta: "Modest investment creates visible local impact",
        flag: "japan.png"
    },
    {
        name: "FC Fujizakura Yamanashi",
        location: "Yamanashi, Japan",
        bio: "Smaller Nadeshiko League side from the mountainous Yamanashi region, focused on community-based operations.",
        potential: [
            "Untapped rural talent in a unique prefecture",
            "Builds the first strong regional women's program"
        ],
        cta: "Low entry cost for regional pride projects",
        flag: "japan.png"
    },
    {
        name: "Veertien Mie Ladies",
        location: "Mie, Japan",
        bio: "Independent club in the Nadeshiko League Division 2, linked to community efforts in the Mie/Kansai area.",
        potential: [
            "High-value proximity to Nagoya and Osaka markets",
            "Supports travel and pro player pathway creation"
        ],
        cta: "Strategic link between major Japanese markets",
        flag: "japan.png"
    },
    {
        name: "Yamato Sylphid",
        location: "Kanagawa, Japan",
        bio: "NPO-style team in the greater Tokyo area, emphasizing grassroots development and educational ties.",
        potential: [
            "Dense population and youth scene advantages",
            "Quick returns through community talent spotting"
        ],
        cta: "High-engagement investment in Tokyo/Kanagawa",
        flag: "japan.png"
    },
    {
        name: "Orca Kamogawa FC",
        location: "Chiba, Japan",
        bio: "Privately and community-run club in the Nadeshiko League known for its grassroots development approach.",
        potential: [
            "Access to the Tokyo metropolitan talent spillover",
            "Sustainable local brand in the Kanto region"
        ],
        cta: "Strategic entry into the Kanto football market",
        flag: "japan.png"
    },
    {
        name: "Speranza Osaka-Takatsuki",
        location: "Osaka, Japan",
        bio: "Independent Nadeshiko League side with strong community roots in the dense Kansai region.",
        potential: [
            "Metropolitan area with huge youth participation",
            "Taps into the deep Kansai football culture"
        ],
        cta: "High-engagement potential in the Osaka market",
        flag: "japan.png"
    },
    {
        name: "Nutty FC",
        location: "Seoul, South Korea",
        bio: "Community-driven initiative founded in 2019 to grow women's football and challenge cultural barriers.",
        potential: [
            "Founder-led club in the heart of the capital",
            "Social impact and sponsorship upside in Seoul"
        ],
        cta: "$10,000 scales recruitment and content creation",
        flag: "skorea.png"
    },
    {
        name: "Yonsei University W-Kicks",
        location: "Seoul, South Korea",
        bio: "The women's football team of prestigious Yonsei University, with a strong history of national titles.",
        potential: [
            "Elite university brand with competitive edge",
            "Direct pathway to national and professional levels"
        ],
        cta: "Support elite student-athlete development",
        flag: "skorea.png"
    },
    {
        name: "Soongsil University REPL",
        location: "Seoul, South Korea",
        bio: "Women's team from Soongsil University, competing at the university level with student-led operations.",
        potential: [
            "Faith-based university with dedicated talent",
            "Amplifies impact in Seoul's student ecosystem"
        ],
        cta: "Funding basics for competitive student play",
        flag: "skorea.png"
    },
    {
        name: "Kyung Hee University Lions",
        location: "Seoul/Gyeonggi, South Korea",
        bio: "Prestigious global university side with a history of recruiting elite student talent amid rising interest.",
        potential: [
            "Leverages prestigious reputation for recruitment",
            "Quick growth in structured talent development"
        ],
        cta: "Invest in prestigious academic-athlete pipelines",
        flag: "skorea.png"
    },
    {
        name: "Seoul Calcio FC",
        location: "Seoul, South Korea",
        bio: "Amateur/community club linked to local football culture, recruiting and training players across the capital.",
        potential: [
            "Taps into the rising Korean amateur participation",
            "Scalable as a feeder club for professional tiers"
        ],
        cta: "$5,000 - $10,000 covers elite annual training",
        flag: "skorea.png"
    },
    {
        name: "Changnyeong WFC",
        location: "Gyeongnam, South Korea",
        bio: "Regional club operating outside the WK League spotlight, focused on provincial development and amateur structures.",
        potential: [
            "High social impact in rural/provincial areas",
            "Taps into national growth of registered players"
        ],
        cta: "Social impact through rural football growth",
        flag: "skorea.png"
    },
    {
        name: "Ridge City FC",
        location: "East Legon, Accra, Ghana",
        bio: "Privately registered club focused on urban women's development in affluent suburbs.",
        potential: [
            "Affluent suburb location for commercial growth",
            "Unlocks high-value local business sponsorships"
        ],
        cta: "Low-cost boost for high commercial growth",
        flag: "gh.png"
    },
    {
        name: "Adidome Unity Ladies",
        location: "Volta Region, Ghana",
        bio: "Grassroots private club founded in 2023 focusing on rural empowerment and talent discovery.",
        potential: [
            "Massive social impact and talent discovery",
            "Rural empowerment model with high visibility"
        ],
        cta: "Tiny investment for massive social impact",
        flag: "gh.png"
    },
    {
        name: "Kayole Starlets",
        location: "Eastlands, Nairobi, Kenya",
        bio: "Independent mid-tier Premier League side acting as a vital talent factory in Eastlands.",
        potential: [
            "Renowned talent factory in Nairobi's Eastlands",
            "High fan engagement and local community growth"
        ],
        cta: "Modest funds push for league stability",
        flag: "ke.png"
    },
    {
        name: "Trinity Starlets",
        location: "Kenya",
        bio: "Small private outfit competing at the top level with extremely limited resources.",
        potential: [
            "Highly competitive despite underfunding",
            "Quick cash injection ensures survival and growth"
        ],
        cta: "Immediate survival and growth investment",
        flag: "ke.png"
    },
    {
        name: "Bungoma Queens",
        location: "Western Kenya",
        bio: "Private lower-tier club focused on developing untapped rural talent in Western Kenya.",
        potential: [
            "Dominant Western Kenya market presence",
            "Low entry cost for high-upside talent sourcing"
        ],
        cta: "Low entry cost for untapped rural markets",
        flag: "ke.png"
    },
    {
        name: "City Lads Ladies F.C.",
        location: "Eastern Cape, South Africa",
        bio: "Independent club operating within SAFA structures in an underserved region.",
        potential: [
            "Eastern Cape regional market exclusivity",
            "Builds a professional presence in Polokwane"
        ],
        cta: "Small funds build local league presence",
        flag: "za.png"
    },
    {
        name: "Copperbelt Ladies",
        location: "Limpopo, South Africa",
        bio: "Private small club creating the first professional pathways in the Limpopo region.",
        potential: [
            "Exclusive access to the Limpopo talent pool",
            "Pioneer professional pathway in the region"
        ],
        cta: "Build the first pro-pathway in Limpopo",
        flag: "za.png"
    },
    {
        name: "First Touch F.C.",
        location: "Polokwane, Limpopo, South Africa",
        bio: "Independent women's side focused on Northern growth and community impact.",
        potential: [
            "Strategic Northern growth area location",
            "Low-cost entry for academy and social impact"
        ],
        cta: "Community impact through elite football",
        flag: "za.png"
    },
    {
        name: "Green Eagles Women FC",
        location: "Zambia",
        bio: "Privately operated club in the ZPL Women's Super League with independent kit operations.",
        potential: [
            "Rapidly growing Zambian league market",
            "Strong regional branding and survival capability"
        ],
        cta: "Modest investment for regional branding",
        flag: "zm.png"
    },
    {
        name: "Aigles de la Médina",
        location: "Dakar, Senegal",
        bio: "Independent women's section of a small private club in a West African coastal hub.",
        potential: [
            "Taps Senegal's young female talent boom",
            "Coastal hub location for West African scouting"
        ],
        cta: "$5,000 taps the Dakar talent boom",
        flag: "sn.png"
    },
    {
        name: "AS Dakar Sacré-Cœur",
        location: "Dakar, Senegal",
        bio: "Privately run program in Dakar with a massive youth population focus.",
        potential: [
            "Dakar location with immense youth density",
            "Creates a West African export pipeline"
        ],
        cta: "Low investment builds an export pipeline",
        flag: "sn.png"
    },
    {
        name: "Diosa Izumo FC",
        location: "Shimane, Japan",
        bio: "Regional Nadeshiko League Division 2 club focusing on western Japan's smaller communities.",
        potential: [
            "High social impact in rural Shimane",
            "Sustainable operations in a niche local market"
        ],
        cta: "Niche market growth with high social impact",
        flag: "japan.png"
    },
    {
        name: "Korea University VAMOS",
        location: "Seoul, South Korea",
        bio: "Independent women's side of Korea University with a passionate student rivalry culture.",
        potential: [
            "Iconic university with a massive alumni network",
            "Low-cost support elevates high-performance gear"
        ],
        cta: "Elevate the Seoul student football ecosystem",
        flag: "skorea.png"
    },
    {
        name: "Hanyang University Lions",
        location: "Seoul, South Korea",
        bio: "Technical university environment focusing on student-athlete development and regional championships.",
        potential: [
            "Technical university talent pipeline",
            "Positions as a feeder in high-population areas"
        ],
        cta: "Support the Hanyang talent pipeline",
        flag: "skorea.png"
    },
    {
        name: "Ewha Womans University",
        location: "Seoul, South Korea",
        bio: "Representing one of the world's largest women's universities, rooted in the 1990s revival.",
        potential: [
            "Enormous all-female student base",
            "Safe, high-visibility spaces for community branding"
        ],
        cta: "Invest in high-visibility community brands",
        flag: "skorea.png"
    },
    {
        name: "Jeju National University",
        location: "Jeju Island, South Korea",
        bio: "Key grassroots outlet and primary women's football hub on Jeju Island.",
        potential: [
            "Untapped rural and insular talent pool",
            "Unique regional market and tourism crossover"
        ],
        cta: "Unique island-based football investment",
        flag: "skorea.png"
    }
];

/* Banner colours cycled by club name for consistent variety */
const BANNER_COLORS = [
    '#0a2a4a',
    '#1a1040',
    '#0d3320',
    '#2a0d1a',
    '#1c2a0a',
    '#0a1a2a',
    '#2a1a0a',
    '#1a0a2a',
    '#0d2020',
    '#1a0d2a'
];

function getBannerColor(name) {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return BANNER_COLORS[Math.abs(hash) % BANNER_COLORS.length];
}

function renderClubCard(club) {
    const bannerColor = getBannerColor(club.name);

    return `
        <article class="fg-club-card-item">
            <div class="fg-club-card-item__banner" style="background: ${bannerColor};">
                <img 
                    src="/images/flags/${club.flag}" 
                    alt="Country Flag" 
                    class="fg-club-card-item__flag"
                >
                <div class="fg-club-card-item__icon">&#x26BD;</div>
                <h3 class="fg-club-card-item__name">${club.name}</h3>
                <p class="fg-club-card-item__location">
                    <span class="fg-club-card-item__loc-dot"></span>
                    ${club.location}
                </p>
            </div>
            <div class="fg-club-card-item__body">
                <p class="fg-club-card-item__bio">${club.bio}</p>
                <div class="fg-club-card-item__potential">
                    <p class="fg-club-card-item__section-label">Investment potential</p>
                    <ul class="fg-club-card-item__bullets">
                        ${club.potential.map(p => `
                            <li class="fg-club-card-item__bullet">
                                <span class="fg-club-card-item__bullet-dot"></span>
                                ${p}
                            </li>
                        `).join('')}
                    </ul>
                </div>
                <p class="fg-club-card-item__cta">${club.cta}</p>
            </div>
        </article>
    `;
}

export class Clubs {
    constructor(containerId) {
        this.containerId = containerId;
        this.activeTab = 'why';
        /** Inline ClubOS iframe (same shell as Clubs page, not a new browser tab). */
        this.clubOsOpen = false;
    }

    myClubEntryHtml() {
        const href = `${CLUB_OS_ORIGIN}/`;
        const open = this.clubOsOpen;
        const embed = open
            ? `
            <div class="fg-my-club-entry__embed-wrap" role="region" aria-label="ClubOS workspace">
                <div class="fg-my-club-entry__embed-toolbar">
                    <span class="fg-my-club-entry__embed-title">ClubOS</span>
                    <div class="fg-my-club-entry__embed-actions">
                        <a class="fg-my-club-entry__embed-link" href="${href}" target="_blank" rel="noopener noreferrer">Open in new tab</a>
                        <button type="button" class="fg-my-club-entry__embed-close" data-action="close-club-os">Close</button>
                    </div>
                </div>
                <iframe
                    class="fg-my-club-entry__iframe"
                    src="${href}"
                    title="ClubOS workspace"
                    loading="lazy"
                    referrerpolicy="strict-origin-when-cross-origin"
                ></iframe>
            </div>
        `
            : '';

        return `
            <div class="fg-my-club-entry">
                <button
                    type="button"
                    class="fg-my-club-entry__btn"
                    data-action="toggle-club-os"
                    aria-expanded="${open}"
                >
                    <span class="fg-my-club-entry__kicker">my club</span>
                    <span class="fg-my-club-entry__sub">${
                        open ? 'Hide ClubOS workspace' : 'Open ClubOS workspace on this page'
                    }</span>
                </button>
                ${embed}
            </div>
        `;
    }

    init() {
        this.injectStyles();
        this.render();
    }

    render() {
        const el = document.getElementById(this.containerId);
        if (!el) return;

        const tabsHtml = `
            <div class="fg-tabs-nav" style="justify-content: center; margin-bottom: 40px;">
                <button class="fg-tabs-nav__item ${this.activeTab === 'why' ? 'active' : ''}" data-tab="why">Thesis</button>
                <button class="fg-tabs-nav__item ${this.activeTab === 'opportunities' ? 'active' : ''}" data-tab="opportunities">Opportunities</button>
                <button class="fg-tabs-nav__item ${this.activeTab === 'performance' ? 'active' : ''}" data-tab="performance">Performance Data</button>
                <button class="fg-tabs-nav__item ${this.activeTab === 'impact' ? 'active' : ''}" data-tab="impact">Impact Report</button>
                <button class="fg-tabs-nav__item ${this.activeTab === 'deal-room' ? 'active' : ''}" data-tab="deal-room">Deal Room</button>
            </div>
        `;

        let contentHtml = '';
        if (this.activeTab === 'why') {
            contentHtml = `
                <div class="fga-animate-up" style="max-width: 800px; margin: 0 auto;">
                    <section class="fg-card" style="padding: 40px; border-radius: 24px;">
                        <h2 class="fg-section-title" style="text-align: left; color: var(--primary-blue); margin-bottom: 24px;">Strategic Investment Thesis</h2>
                        <div style="line-height: 1.8; color: var(--text-secondary); font-size: 1.1rem;">
                            <p style="margin-bottom: 20px;">
                                At <strong>footballgirl</strong>, we have identified these independent clubs as the premier vehicles for future investment in the global women’s football ecosystem. Our selection is driven by data-centric criteria including high-growth geographic locations, proven player development pipelines, and operational stability.
                            </p>
                            <p style="margin-bottom: 20px;">
                                For institutional partners and the financial market—including <strong>financial asset managers</strong>—these clubs represent a unique, uncorrelated asset class. We focus on undervalued markets where the cost of entry allows for transformative community impact alongside significant commercial upside.
                            </p>
                            <div style="background: #f0f7ff; border-left: 4px solid var(--primary-blue); padding: 24px; border-radius: 12px; margin-top: 32px;">
                                <h3 style="font-size: 1.1rem; color: var(--text-primary); margin-bottom: 12px; font-weight: 800;">Investment Selection Criteria</h3>
                                <ul style="list-style: none; padding: 0; display: flex; flex-direction: column; gap: 12px;">
                                    <li style="display: flex; gap: 10px;"><strong>📍 Location Optimization:</strong> High youth density markets with rising infrastructure support.</li>
                                    <li style="display: flex; gap: 10px;"><strong>📈 Export Potential:</strong> Clubs with established histories of talent migration to elite professional tiers.</li>
                                    <li style="display: flex; gap: 10px;"><strong>⚡ Capital Efficiency:</strong> Lean operations where modest investment produces immediate transformative ROI.</li>
                                </ul>
                            </div>
                        </div>
                    </section>
                </div>
            `;
        } else if (this.activeTab === 'opportunities') {
            contentHtml = `
                <div class="fg-clubs-grid">
                    ${CLUBS_DATA.map(renderClubCard).join('')}
                </div>
            `;
        } else if (this.activeTab === 'performance') {
            contentHtml = `
                <div class="fga-animate-up" style="max-width: 800px; margin: 0 auto; text-align: center;">
                    <section class="fg-card" style="padding: 60px 40px;">
                        <div style="font-size: 3rem; margin-bottom: 20px;">📊</div>
                        <h2 class="fg-section-title">Market Performance Metrics</h2>
                        <p class="fg-prose">Quarterly projections on player valuation growth and youth academy ROI are currently restricted to verified institutional partners.</p>
                        <button class="fg-btn fg-btn--primary" style="width: auto; padding: 12px 32px;">Request Access to Data Room</button>
                    </section>
                </div>
            `;
        } else if (this.activeTab === 'impact') {
            contentHtml = `
                <div class="fga-animate-up" style="max-width: 800px; margin: 0 auto; text-align: center;">
                    <section class="fg-card" style="padding: 60px 40px;">
                        <div style="font-size: 3rem; margin-bottom: 20px;">✨</div>
                        <h2 class="fg-section-title">ESG & Community Impact</h2>
                        <p class="fg-prose">Our investment framework prioritizes social mobility and gender equity. View our 2026 methodology for measuring local economic impact through sports infrastructure.</p>
                        <button class="fg-btn" style="width: auto; padding: 12px 32px;">View Impact Framework</button>
                    </section>
                </div>
            `;
        } else if (this.activeTab === 'deal-room') {
            contentHtml = `
                <div class="fga-animate-up" style="max-width: 800px; margin: 0 auto; text-align: center;">
                    <section class="fg-card" style="padding: 60px 40px; border: 2px solid var(--primary-blue);">
                        <div style="font-size: 3rem; margin-bottom: 20px;">🔒</div>
                        <h2 class="fg-section-title">Secure Deal Room</h2>
                        <p class="fg-prose">Access detailed club financials, ownership structures, and term sheets for active investment rounds.</p>
                        <div style="display: flex; gap: 12px; justify-content: center; margin-top: 24px;">
                            <button class="fg-btn fg-btn--primary" style="width: auto; padding: 12px 32px;">Institutional Login</button>
                            <button class="fg-btn" style="width: auto; padding: 12px 32px;">Contact for KYC</button>
                        </div>
                    </section>
                </div>
            `;
        }

        el.innerHTML = sidebarPage({
            title: 'Clubs',
            subtitle: 'Institutional-grade investment opportunities in independent women\'s football.',
            main: tabsHtml + this.myClubEntryHtml() + contentHtml,
            wide: true
        });

        this.attachListeners(el);
    }

    injectStyles() {
        const styleId = 'fga-clubs-styles-v2';
        if (document.getElementById(styleId)) return;
        const css = `
            .fga-animate-up { animation: fgaUp 0.6s cubic-bezier(0.22, 1, 0.36, 1) forwards; opacity: 0; }
            @keyframes fgaUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
            .fg-my-club-entry { margin-top: 12px; margin-bottom: 8px; width: 100%; }
            .fg-my-club-entry__btn {
                display: flex; flex-direction: column; align-items: center; justify-content: center;
                width: 100%; padding: 22px 28px; border-radius: 18px;
                background: #ffffff;
                border: 1px solid rgba(15, 23, 42, 0.12);
                box-shadow: 0 10px 36px rgba(15, 23, 42, 0.08);
                color: inherit;
                cursor: pointer;
                font-family: inherit;
                transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
            }
            .fg-my-club-entry__btn:hover {
                transform: translateY(-2px);
                border-color: rgba(37, 99, 235, 0.35);
                box-shadow: 0 14px 40px rgba(37, 99, 235, 0.12), 0 8px 24px rgba(15, 23, 42, 0.08);
            }
            .fg-my-club-entry__btn:active { transform: scale(0.98); }
            .fg-my-club-entry__kicker {
                font-size: 0.72rem; font-weight: 800; letter-spacing: 0.22em; text-transform: uppercase;
                color: var(--primary-blue, #2563eb); margin-bottom: 8px;
            }
            .fg-my-club-entry__sub {
                font-size: 1rem; font-weight: 700;
                color: var(--text-primary, #1e293b);
            }
            .fg-my-club-entry__embed-wrap {
                margin-top: 16px;
                border-radius: 18px;
                overflow: hidden;
                border: 1px solid rgba(15, 23, 42, 0.12);
                background: #f8fafc;
                box-shadow: 0 12px 40px rgba(15, 23, 42, 0.1);
            }
            .fg-my-club-entry__embed-toolbar {
                display: flex; align-items: center; justify-content: space-between; gap: 12px;
                flex-wrap: wrap;
                padding: 10px 14px;
                background: #ffffff;
                border-bottom: 1px solid rgba(15, 23, 42, 0.08);
            }
            .fg-my-club-entry__embed-title {
                font-size: 0.75rem; font-weight: 800; letter-spacing: 0.14em;
                text-transform: uppercase;
                color: var(--text-secondary, #64748b);
            }
            .fg-my-club-entry__embed-actions {
                display: flex; align-items: center; gap: 10px;
            }
            .fg-my-club-entry__embed-link {
                font-size: 0.85rem; font-weight: 600;
                color: var(--primary-blue, #2563eb);
                text-decoration: none;
            }
            .fg-my-club-entry__embed-link:hover { text-decoration: underline; }
            .fg-my-club-entry__embed-close {
                padding: 8px 14px;
                border-radius: 10px;
                border: 1px solid rgba(15, 23, 42, 0.15);
                background: #ffffff;
                font-size: 0.85rem; font-weight: 600;
                color: var(--text-primary, #1e293b);
                cursor: pointer;
                font-family: inherit;
            }
            .fg-my-club-entry__embed-close:hover {
                border-color: rgba(37, 99, 235, 0.35);
                color: var(--primary-blue, #2563eb);
            }
            .fg-my-club-entry__iframe {
                display: block;
                width: 100%;
                min-height: min(72vh, 820px);
                height: min(72vh, 820px);
                border: 0;
                background: #fff;
            }
        `;
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = css;
        document.head.appendChild(style);
    }

    attachListeners(el) {
        el.querySelectorAll('.fg-tabs-nav__item').forEach(btn => {
            btn.onclick = () => {
                this.activeTab = btn.dataset.tab;
                this.clubOsOpen = false;
                this.render();
                window.scrollTo(0, 0);
            };
        });

        const toggleClubOs = el.querySelector('[data-action="toggle-club-os"]');
        if (toggleClubOs) {
            toggleClubOs.onclick = () => {
                this.clubOsOpen = !this.clubOsOpen;
                this.render();
                if (this.clubOsOpen) {
                    requestAnimationFrame(() => {
                        el.querySelector('.fg-my-club-entry__embed-wrap')?.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest'
                        });
                    });
                }
            };
        }

        const closeClubOs = el.querySelector('[data-action="close-club-os"]');
        if (closeClubOs) {
            closeClubOs.onclick = () => {
                this.clubOsOpen = false;
                this.render();
            };
        }
    }
}